import { useMemo } from 'react';

/**
 * Get short name for an environment name
 */
export const useEnvironmentShortcut = (
  env: string = import.meta.env.MODE
) => {
  const shortcut = useMemo(() => {
    switch (env) {
      case 'production':
        return 'prod';
      case 'development':
      case 'staging':
        return 'dev';
      case 'test':
        return 'test';
      default:
        return 'local';
    }
  }, []);

  return shortcut;
};
